export default "__VITE_ASSET__rxbqBRHNuSGzM2uw8EEZ8g__"